import { lazy } from 'react';

import { PUBLIC_ROUTES } from 'constants/publicPaths';

const PublicUnusualOperations = lazy(
  () => import('views/Compliance/PublicUnusualOperations'),
);

const PublicComplaintCenter = lazy(
  () => import('views/Compliance/PublicComplaintCenter'),
);

const routes = [
  {
    path: PUBLIC_ROUTES.unusualOperationsLine,
    exact: true,
    component: PublicUnusualOperations,
  },
  {
    path: PUBLIC_ROUTES.publicComplaint,
    exact: true,
    component: PublicComplaintCenter,
  },
];

export default routes;
